// extracted by mini-css-extract-plugin
module.exports =  {"copy":"j_sVF4ZbONTfyXWLLgZO","code":"rBIwfeYfMWR09KXuPN0A"};